var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-backlink"},[_c('a',_vm._b({},'a',_vm.$attrs,false),[_c('b-icon',{attrs:{"icon":"arrow-left"}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }